export const KIOSK_TAB = {
  INVENTORY: 'Inventory',
};

export const KIOSK_TABS = Object.values(KIOSK_TAB);
